<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-trigger-click class="cursor-pointer">
    <feather-icon icon="CalendarIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="badge"/>

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">แจ้งเตือนติดตามนัดชำระเงิน</h3>
      </div>

      <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0"
                 :settings="settings" component="">
        <ul class="bordered-items">
          <li v-for="notification in _notificationsPaymentSchedule" :key="notification.stage"
              class="flex justify-between px-4 py-4 notification cursor-pointer"
              @click="links(notification.action, notification.userId ? notification.userId : 'undefined')">
            <div class="flex items-start">
              <feather-icon :icon="notification.icon"
                            :svgClasses="[`text-${notification.color}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
              <div class="mx-2">
                <span class="font-medium block notification-title"
                      :class="[`text-${notification.color}`]">{{ notification.title }}</span>
                <small>{{ notification.msg }}</small>
              </div>
            </div>
            <small class="mt-1 whitespace-no-wrap">{{ notification.summary }} สัญญา</small>
          </li>
        </ul>
      </component>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
/* eslint-disable no-mixed-spaces-and-tabs */
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {createNamespacedHelpers} from 'vuex'
import {round} from '@/utils'
import {INotiCallExActionType} from "@/constants/interface";

const {mapActions: mapNotificationActions, mapState: mapNotificationState} = createNamespacedHelpers('Notification');

export default {
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      settings: {
        interval: 10000,// 1,000 = 1 sec, 10,000 = 1 minute, 100,000 = 10 minute
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  async created() {
    const vm = this
    const {getNotificationsPaymentSchedule} = this
    getNotificationsPaymentSchedule()
    setInterval(function () {
      getNotificationsPaymentSchedule()
    }, vm.settings.interval);
  },
  computed: {
    ...mapNotificationState([
      'status',
      'notificationsPaymentSchedule',
    ]),
    _notificationsPaymentSchedule() {
      return this.notificationsPaymentSchedule;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    badge() {
      let badge = this.notificationsPaymentSchedule.filter(res => res.stage === INotiCallExActionType.ntfAll).reduce((sum, res) => {
        return sum + round(res.summary, 2);
      }, 0)
      return badge > 0 ? badge : ''
    }
  },
  methods: {
    ...mapNotificationActions(['getNotificationsPaymentSchedule']),
    links(action) {
      document.getElementById('content-area').click();
      let page = 'notification-payment-schedule-list'
      this.$router.push({name: 'redir', params: {page, action}});
    },
  }
}

</script>

